import React from 'react';

const styles = ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: "column"
  },

  title: {
    fontFamily: 'verdana',
    fontSize: 14,
    letterSpacing: 0.1,
    color: "#666666",
  },

  selector: {
    width: '100%',
    height: '40px',
    border: 'none',
    borderBottom: '1px solid gray',
    outline: 'none'
  },

  selectOption: {
    height: '10px',
    fontFamily: 'verdana',
    textTransform: 'capitalize',
    fontSize: 14,
    letterSpacing: 0.1,
  }
});

const OrganizationTypeSelector = (props) => {
  const { orgType, setOrgType, record } = props
  let recordType = 'default'

  if (record) {
    const { is_channel_partner, is_law_enforcement } = record
    if (is_channel_partner)  recordType = 'cpartner'
    else if (is_law_enforcement) recordType = 'law'
  }

  return <div style={styles.container}>
    <div style={styles.title}>Organization Type:</div>
    <select style={styles.selector} value={orgType || recordType || 'default'} onChange={(evt) => {
      setOrgType(evt.target.value)
    }}>
      <option style={styles.selectOption} value="default">Is Default Organization</option>
      <option style={styles.selectOption} value="law">Is Law Enforcement Organization</option>
      <option style={styles.selectOption} value="cpartner">Is Channel Organization</option>
    </select>
  </div>
}

export default OrganizationTypeSelector